export const SLICE_NAME = {
  APP: 'app',
  INVOICE: 'invoice',
  PAY_PLAN_FEATURE: 'pay_plan_feature',
  PROPERTY_LIST_FEATURE: 'property_list_feature',
}
